export default "__VITE_PUBLIC_ASSET__629c5458__"